import React, { useEffect } from "react";
import { Switch, Route, useParams } from "react-router-dom";
import { usePageTitle } from "src/app/title-management/usePageTitle";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/reducers";
import {
  clearInsightsDashboardState,
  getDashboardList,
  getSetupConfig,
} from "src/redux";
import { AccessDenied } from "src/app/AccessDenied/AccessDenied";
import { SocialInsightsDashboardsListPage } from "./SocialInsightsDashboardsListPage";
import { SocialInsightsDashboardDetailPage } from "./SocialInsightsDashboardDetailPage";

export const SocialInsights = () => {
  usePageTitle("Social Insights Dashboard");

  const dispatch = useDispatch();

  const { workspaceUuid } = useParams<{ workspaceUuid: string }>();

  const { dashboardListFirstLoadDone, setupConfig, accessDenied } = useSelector(
    (state: RootState) => state.insightsDashboardReducer,
  );

  useEffect(() => {
    if (!dashboardListFirstLoadDone) {
      dispatch(getDashboardList(workspaceUuid));
    }
    if (!setupConfig) {
      dispatch(getSetupConfig(workspaceUuid));
    }

    return () => {
      dispatch(clearInsightsDashboardState());
    };
  }, []);

  if (accessDenied)
    return (
      <>
        <br />
        <br />
        <br />
        <AccessDenied />
      </>
    );

  return (
    <Switch>
      <Route
        exact
        path="/workspace/:workspaceUuid/social-insights"
        component={SocialInsightsDashboardsListPage}
      />
      <Route
        path="/workspace/:workspaceUuid/social-insights/:dashboardId"
        component={SocialInsightsDashboardDetailPage}
      />
    </Switch>
  );
};
